import { OverlayProvider } from 'overlay-kit';

import { QueryProvider } from '@/app/providers/query-client';
import { SessionProvider } from '@/app/providers/session-provider';
import { AnalyticsProvider } from '@/shared/analytics/posthog-provider';
import { ToastProvider } from '@/shared/ui/toast-provider';
import type { PropsWithChildren } from 'react';

export const AppProviders = ({ children }: PropsWithChildren) => (
  <QueryProvider>
    <OverlayProvider>
      <ToastProvider>
        <AnalyticsProvider>
          <SessionProvider>{children}</SessionProvider>
        </AnalyticsProvider>
      </ToastProvider>
    </OverlayProvider>
  </QueryProvider>
);
